var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { attrs: { link: "official-code" } },
    [
      _c(
        "tile-title",
        { attrs: { slot: "tileHeader", icon: "map-o" }, slot: "tileHeader" },
        [_vm._v("Официальные коды")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "htmlContent",
          staticClass: "table-container",
          attrs: { slot: "tileContent" },
          slot: "tileContent",
        },
        [
          _vm.codesList.length > 0
            ? _c("table", { staticClass: "codes-table" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.codesList, function (c, i) {
                    return _c("tr", { key: i }, [
                      _vm.codesData[c].code
                        ? _c("td", { staticClass: "codes-first-column" }, [
                            _vm._v(_vm._s(_vm.getRussianCodeName(c, _vm.type))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.codesData[c].code
                        ? _c("td", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.codesData[c].code) +
                                "\n                        "
                            ),
                            _vm.codesData[c].descr
                              ? _c("span", [
                                  _vm._v(
                                    " - " + _vm._s(_vm.codesData[c].descr)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.codesData[c].date
                              ? _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(_vm.codesData[c].date) + ")"
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-container",
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _c("tilePrintPdf", {
            attrs: {
              html: _vm.htmlForPrint,
              title: _vm.title,
              printStyle: _vm.printStyle,
              filename: "Official_codes",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }